<template>
        <DashboardCard
                :width="width"
                :dataDisplay="dataDisplay"
                :main_icon="main_icon"
                :icons="icon_data"
                :load_url="load_url"
                :title="title">
        </DashboardCard>
</template>

<script>
    import DashboardCard from '../../widgets/DashboardCard';
    export default {
        name: 'PackageIntake',
        components: {DashboardCard},
        props: {
            width: {type:Number, default: 25},
            dataDisplay: {type:String, default: null},
        },
        data() {
            return {
                main_icon: 'fa-light fa-box-circle-check',
                color: '#5bc0de',
                title: 'Package Intake',
                load_url: '/dashboards/intake/data',
                icon_data: [
                    {
                        name: 'Expected',
//                        name: 'Expected Packages',
                        text_color: '#2A9D8F',
                    },
                    {
//                        name: 'Total Packages Received',
                        name: 'Packages Received',
                        text_color: '#264653',
                    },
                    {
                        name: 'Outstanding',
//                        name: 'Packages Outstanding',
                        text_color: '#F4A261',
                    },
                    {
                        name: 'Orders Received',
                        text_color: '#E76F51',
                     },
                ],
            };
        },
    };
</script>

<style scoped>

</style>